@if(inMaintenance()){
  <app-inactive-platform></app-inactive-platform>
}
<!-- @else if (loginTest() && !inProduction()) {
<app-login></app-login>
}  -->
@else {
<router-outlet></router-outlet>
}

@if (modal.isOpen()) {
  <app-father-modal> </app-father-modal>
}
<!-- <app-cookie-consent></app-cookie-consent> -->